<script setup lang="ts">
import { Components } from '@/api/generated/api';
import CompletedBadge from '@/core/badges/CompletedBadge.vue';
import StudentRecipientSummary from '@/core/elements/StudentRecipientSummary.vue';
import { dateToHHmm, getDateForObservationTimeline } from '@/utils/date.utils';
import { findFocusedStudent } from '@/utils/students.utils';
import { computed } from 'vue';

const props = defineProps<{
  completedAt: string;
  note: string | null;
  /** Student view: names this student and counts the other recipients. */
  selectedStudentId?: number | null;
  students: Components.Schemas.SupportMeasureEntryDto['students'];
}>();

const dateText = computed<string>(
  () => `${getDateForObservationTimeline(props.completedAt)} · ${dateToHHmm(props.completedAt)}`,
);

const focusedStudent = computed(() => findFocusedStudent(props.students, props.selectedStudentId));
</script>

<template>
  <div class="rounded-group border border-green/40 bg-green p-md">
    <div class="flex items-start justify-between gap-sm">
      <span class="text-green-strong text-footer font-semibold">{{ dateText }}</span>
      <CompletedBadge />
    </div>

    <p v-if="note" class="text-body mt-md whitespace-pre-line break-words">{{ note }}</p>

    <StudentRecipientSummary
      v-if="students.length"
      class="mt-md"
      :focused-student="focusedStudent"
      label-class="text-green-strong"
      :students="students"
    />
  </div>
</template>
